// Copyright (c) 2026 Yunus YILDIZ — SPDX-License-Identifier: BUSL-1.1

import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/Button'
import { Input } from '@/components/ui/Input'
import { Alert } from '@/components/ui/Alert'
import { ROUTES } from '@/constants/routes'
import { apiClient } from '@/lib/api/client'

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('')
  const [submitted, setSubmitted] = useState(false)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    setLoading(true)
    setError('')
    try {
      await apiClient.post('/v1/auth/forgot-password', { email })
      setSubmitted(true)
    } catch {
      setError('Something went wrong. Please try again.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-canvas px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <img src="/etapsky_mark.svg" alt="Etapsky" className="h-10 w-10 mx-auto mb-3" />
          <h1 className="text-xl font-bold text-ink">Reset your password</h1>
          <p className="mt-1 text-sm text-ink-muted">We'll send a reset link to your email</p>
        </div>

        <div className="card p-6">
          {submitted ? (
            <Alert variant="success" title="Check your email">
              If an account exists for that address, we sent a reset link. It expires in 15 minutes.
            </Alert>
          ) : (
            <form onSubmit={(e) => void handleSubmit(e)} className="space-y-4">
              {error && <Alert variant="error">{error}</Alert>}
              <Input
                label="Email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@company.com"
                required
              />
              <Button type="submit" className="w-full" loading={loading}>
                Send reset link
              </Button>
            </form>
          )}
        </div>

        <p className="mt-4 text-center text-sm text-ink-muted">
          <Link to={ROUTES.LOGIN} className="text-brand hover:underline">← Back to sign in</Link>
        </p>
      </div>
    </div>
  )
}
